module.exports = __webpack_public_path__ + "static/media/forbes-bw.ef517d9a.png";